// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2L7gI","content":"RecentSearches_content__3pGb3"};